import TopButton from "./shared-components/TopButton/TopButton";
import {
  BrowserRouter as Main,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import ScrollToTop from "./utilis/ScrollToTop";

// Home Import Start
import HomeV1 from "./views/home/home-v1/HomeV1";
import HomeV2 from "./views/home/home-v2/HomeV2";
import HomeV3 from "./views/home/home-v3/HomeV3";
import HomeV4 from "./views/home/home-v4/HomeV4";
import HomeV5 from "./views/home/home-v5/HomeV5";
// Home Import End

// Explore Import Start
import HelpCenter from "./views/explore/help-center/HelpCenter";
import ConnectWallet from "./views/explore/conect-wallet/ConnectWallet";
import Create from "./views/explore/create/Create";
import Explore from "./views/explore/explore/Explore";
import Profile from "./views/explore/profile/Profile";
// Explore Import End

// Pages Import Start
import Activity from "./views/pages/activity/Activity";
import Author from "./views/pages/author/Author";
import Collection from "./views/pages/collection/Collection";
import CommingSoon from "./views/pages/comming-soon/CommingSoon";
import Error404 from "./views/pages/error-404/Error404";
import ItemDetails from "./views/pages/item-details/ItemDetails";
import Login from "./views/pages/login/Login";
import ProfileEdit from "./views/pages/profile-edit/ProfileEdit";
import Ranking from "./views/pages/ranking/Ranking";
import Register from "./views/pages/register/Register";
import Upload from "./views/pages/upload/Upload";
// import Adminpanel from "./adminpanel/Adminpanel";
// Pages Import End

// Blog Import Start
import Blog from "./views/blog/blog/Blog";
import BlogDetail from "./views/blog/blog-detail/BlogDetail";
import Header from "./shared-components/Header/Header";
import Preloader from "./shared-components/Preloader/Preloader";
import Footer from "./shared-components/Footer/Footer";
// Blog Import End

// Contact Import Start
import Contact from "./views/contact/contact/Contact";
// Contact Import Start

function App() {
  return (
    <>
      <Main>
        <Preloader />
        <ScrollToTop />
        <Header
          headerMainClassList="header-main love-sticky fixed-top"
          headerInnerClassList="header-inner position-relative"
          logoImgSrc="/img/logo.svg"
          submitImgSrc="/img/icons/search.svg"
        />
        <Routes>
          <Route exact path="home-v1" element={<HomeV1 />}></Route>

          {/* Home Start */}

          <Route path="/">
            <Route exact path="/" element={<HomeV1 />}></Route>
            <Route exact path="home-v2" element={<HomeV2 />}></Route>
            <Route exact path="home-v3" element={<HomeV3 />}></Route>
            <Route exact path="home-v4" element={<HomeV4 />}></Route>
            <Route exact path="home-v5" element={<HomeV5 />}></Route>
          </Route>

          {/* Home End */}

          {/* Explore Start */}
          <Route exact path="explore">
            <Route exact path="explore" element={<Explore />}></Route>
            <Route exact path="profile" element={<Profile />}></Route>
            <Route exact path="create" element={<Create />}></Route>
            <Route exact path="create/upload" element={<Upload />}></Route>
            <Route exact path="wallet" element={<ConnectWallet />}></Route>
            <Route exact path="help-center" element={<HelpCenter />}></Route>
          </Route>
          {/* Explore End */}

          {/* Pages Start */}
          <Route exact path="pages">
            <Route exact path="activity" element={<Activity />}></Route>
            <Route exact path="author" element={<Author />}></Route>
            <Route exact path="collection" element={<Collection />}></Route>
            <Route exact path="coming-soon" element={<CommingSoon />}></Route>
            <Route exact path="error404" element={<Error404 />}></Route>
            <Route exact path="item-details" element={<ItemDetails />}></Route>
            <Route exact path="login" element={<Login />}></Route>
            <Route exact path="profile-edit" element={<ProfileEdit />}></Route>
            <Route exact path="ranking" element={<Ranking />}></Route>
            <Route exact path="register" element={<Register />}></Route>
            {/* <Route exact path="panel" element={<Adminpanel />}></Route> */}
          </Route>
          {/* Pages End */}

          {/* Blog Start */}
          <Route exact path="blogs">
            <Route exact path="all" element={<Blog />} />
            <Route exact path=":id" element={<BlogDetail />} />
          </Route>
          {/* Blog End */}

          {/* Contact Start */}
          <Route exact path="contact" element={<Contact />}>
            <Route exact path="contact" element={<Contact />}></Route>
          </Route>
          {/* Contact End */}

          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>

        <Footer
          footerClasses="copyright-content text-center text-white mt-5"
          textWhite={true}
          footerType="1"
        />

        <TopButton />
      </Main>
    </>
  );
}

export default App;
